"use strict";

var _slicedToArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/slicedToArray.js").default;
var _regeneratorRuntime = require("/vercel/path0/node_modules/@babel/runtime/helpers/regeneratorRuntime.js").default;
var _asyncToGenerator = require("/vercel/path0/node_modules/@babel/runtime/helpers/asyncToGenerator.js").default;
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var qrcode_modal_1 = __importDefault(require("@walletconnect/qrcode-modal"));
var walletconnect_1 = __importDefault(require("@web3-onboard/walletconnect"));
var common_1 = require("@web3-onboard/common");
var platform_1 = require("../../../base/utils/platform");
var icons_1 = require("./icons");
var types_1 = require("./types");
function customWcModule(options) {
  var label = options.customLabelFor,
    connectFirstChainId = options.connectFirstChainId,
    _options$qrcodeModalO = options.qrcodeModalOptions,
    qrcodeModalOptions = _options$qrcodeModalO === void 0 ? {} : _options$qrcodeModalO,
    _options$bridge = options.bridge,
    bridge = _options$bridge === void 0 ? "https://bridge.walletconnect.org" : _options$bridge;
  var defaultWc = (0, walletconnect_1.default)({
    bridge: bridge
  });
  if (!(0, platform_1.isMobile)()) {
    qrcodeModalOptions.desktopLinks = ["ZenGo"];
  }
  return function () {
    var wc = defaultWc({
      device: (0, platform_1.getDevice)()
    });
    var getInterface = wc.getInterface;
    wc.label = types_1.CustomLabels[label];
    wc.getIcon = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", icons_1.icons[label]);
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    wc.getInterface = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(helpers) {
        var ui, provider, connector, request, killSession;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return getInterface(helpers);
            case 2:
              ui = _context4.sent;
              provider = ui.provider;
              connector = provider.connector, request = provider.request;
              killSession = connector.killSession; // hack QR code opts
              connector._qrcodeModalOptions = qrcodeModalOptions;
              // hotfix: multiple killSession request send causing peerId error at disconnect
              connector.killSession = /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(sessionError) {
                  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        if (this._connected) {
                          _context2.next = 2;
                          break;
                        }
                        return _context2.abrupt("return");
                      case 2:
                        _context2.next = 4;
                        return killSession.call(this, sessionError);
                      case 4:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2, this);
                }));
                return function (_x2) {
                  return _ref3.apply(this, arguments);
                };
              }();
              // hack requests, SHOULD be function to keep provider instance's 'this' context
              provider.request = /*#__PURE__*/function () {
                var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(_ref4) {
                  var _this = this;
                  var method, params;
                  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        method = _ref4.method, params = _ref4.params;
                        if (!(method !== "eth_requestAccounts")) {
                          _context3.next = 3;
                          break;
                        }
                        return _context3.abrupt("return", request({
                          method: method,
                          params: params
                        }));
                      case 3:
                        return _context3.abrupt("return", new Promise(function (resolve, reject) {
                          // Check if connection is already established
                          if (!_this.connector.connected) {
                            // create new session
                            void _this.connector.createSession(connectFirstChainId ? {
                              chainId: parseInt(_this.chains[0].id, 16)
                            } : undefined).then(function () {
                              if (label === "zengo" && (0, platform_1.isMobile)()) {
                                window.open("https://get.zengo.com/wc?uri=".concat(encodeURIComponent(_this.connector.uri)), "_blank");
                              } else {
                                qrcode_modal_1.default.open(_this.connector.uri, function () {
                                  return reject(new common_1.ProviderRpcError({
                                    code: 4001,
                                    message: "User rejected the request."
                                  }));
                                }, qrcodeModalOptions);
                              }
                            });
                          } else {
                            var _this$connector$sessi = _this.connector.session,
                              accounts = _this$connector$sessi.accounts,
                              chainId = _this$connector$sessi.chainId;
                            _this.emit("chainChanged", "0x".concat(chainId.toString(16)));
                            return resolve(accounts);
                          }
                          // Subscribe to connection events
                          (0, rxjs_1.fromEvent)(_this.connector, "connect", function (error, payload) {
                            if (error) {
                              throw error;
                            }
                            return payload;
                          }).pipe((0, operators_1.take)(1)).subscribe({
                            next: function next(_ref6) {
                              var params = _ref6.params;
                              var _params = _slicedToArray(params, 1),
                                _params$ = _params[0],
                                accounts = _params$.accounts,
                                chainId = _params$.chainId;
                              _this.emit("accountsChanged", accounts);
                              _this.emit("chainChanged", "0x".concat(chainId.toString(16)));
                              qrcode_modal_1.default.close();
                              resolve(accounts);
                            },
                            error: reject
                          });
                        }));
                      case 4:
                      case "end":
                        return _context3.stop();
                    }
                  }, _callee3);
                }));
                return function (_x3) {
                  return _ref5.apply(this, arguments);
                };
              }();
              return _context4.abrupt("return", ui);
            case 10:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    return wc;
  };
}
exports.default = customWcModule;